module.exports = __webpack_public_path__ + "static/media/Info.544ed54f.png";